export const SURVEY_HEADING =
  "Please tell us about your package booking experience";

export const BOOK_REASON_HEADING = "I booked this package because:";
export const WOULD_BOOK_ANYWAY_HEADING =
  "Would you have booked this trip on Capital One Travel anyway?";

export const BOOK_REASONS = ["It was convenient", "It was cheaper", "Both"];
export const WOULD_BOOK_ANYWAY_RESPONSES = ["Yes", "Not likely"];

export const ERROR_MESSAGE =
  "Please complete all required questions to submit.";

export const SUBMIT_CTA_TEXT = "Submit";
export const SUBMIT_CTA_SUBMITTING_TEXT = "Submitting...";

export const SUBMIT_SUCCESS_MESSAGE =
  "Thanks for taking the time to share your feedback with us!";
